import { render, staticRenderFns } from "./companyBranchCreateModal.vue?vue&type=template&id=47d8025a&"
import script from "./companyBranchCreateModal.vue?vue&type=script&lang=ts&"
export * from "./companyBranchCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports